// extracted by mini-css-extract-plugin
module.exports = {"badge":"badge-skins-smallOnWide-badge-6ab4eade"};